/* eslint-disable max-classes-per-file */

// log errors
export const logError = (error, context = {}) => {
  // Log error to console (replacing Sentry since moving to Datadog)
  console.error('Error logged:', error);
  if (Object.keys(context).length > 0) {
    console.error('Error context:', context);
  }
};

export class InvalidGeoJsonError extends Error {
  constructor() {
    super('Error: Not a valid GeoJSON');
  }
}
export class UnsupportedFeaturesError extends Error {
  /**
   * @param {string[]} features - The list of supported features.
   */
  constructor(features) {
    super(`Warning: All features except ${features} will be ignored`);
  }
}

export class NoSupportedFeaturesError extends Error {
  /**
   * @param {string[]} features - The list of supported features.
   */
  constructor(features) {
    super(
      `There are no supported features in your GeoJSON. Only supported features are ${features}`
    );
  }
}
